import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfStripe.module.scss';
import { Image, Container, RichText, Button } from '@/components';
import { NetspendContext } from 'library/contexts/NetspendContext';
import { useContext, useEffect, useRef } from 'react';

let cx = classNames.bind(styles);

export default function AcfStripe(props) {
	const { stripe, attributes } = props;
	const className = attributes.className?.split(' ') || [];
	const stripeElem = useRef(null);

	const { setStripeHeight } = useContext(NetspendContext);

	function updateStripeHeight() {
		setStripeHeight(Math.floor(stripeElem.current.getBoundingClientRect().height));
	}

	useEffect(() => {
		window.addEventListener('resize', updateStripeHeight);
		setStripeHeight(Math.floor(stripeElem.current.getBoundingClientRect().height));
		return () => {
			window.removeEventListener('resize', updateStripeHeight);
			setStripeHeight(null);
		};
	});

	const mobileInlineLink = stripe.cta && stripe.cta.title ? (
    ` <a href="${stripe.cta.url}" target="${stripe.cta.target}" class="stripe-mobile-cta" rel="${stripe.cta.target === '_blank' ? 'roreferrer noopener' : ''}" >${stripe.cta.title}</a>`
   ) : '';

	return (
		<section id={attributes.anchor} className={cx(['ns_stripe', 'stripe', ...className, stripe.backgroundColor[0] && `bg-${stripe.backgroundColor[0]}`])} ref={stripeElem}>
			<Container className={cx(['stripe-container'])}>
				<div className={cx(['icon-and-text-container'])}>
					{stripe.icon && (
						<div className={cx(['icon-container'])}>
							<Image image={stripe.icon} objectFit={'contain'} fill={true} className={cx(['ns_stripe-icon', 'icon'])} />
						</div>
					)}
					{stripe.text && <RichText elem='p' className={cx(['text', 'is-font-size-sm'])} html={`${stripe.text}${mobileInlineLink}`} />}
				</div>
				{stripe.cta && stripe.cta.title && (
					<Button href={stripe.cta.url} target={stripe.cta.target} outlined={stripe.outlinedCtaButton}>
						{stripe.cta.title}
					</Button>
				)}
			</Container>
		</section>
	);
}

AcfStripe.fragments = {
	key: `AcfStripeFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfStripeFragment on AcfStripe {
			attributes {
				anchor
				className
			}
			stripe {
				backgroundColor
				cta {
					target
					title
					url
				}
				icon {
					...ImageFragment
				}
				outlinedCtaButton
				text
			}
		}
	`,
};

AcfStripe.config = {
	name: 'AcfStripe',
};
AcfStripe.displayName = 'AcfStripe';
